import { useQuery } from '@sixfold/app-data-framework';
import { isNil } from '@sixfold/typed-primitives';

import { VisibilityAgentEnabledQuery, VisibilityAgentEnabledQueryVariables } from '../../lib/graphql';
import { useLastViewedCompanyId } from '../../lib/util/use_last_viewed_context';
import { visibilityAgentEnabled } from '../graphql';

export function useIsVisibilityAgentEnabled(): boolean | undefined {
  const [lastViewedCompanyId] = useLastViewedCompanyId();
  const { data, loading } = useQuery<VisibilityAgentEnabledQuery, VisibilityAgentEnabledQueryVariables>(
    visibilityAgentEnabled,
    {
      variables: { companyId: lastViewedCompanyId ?? null },
      skip: isNil(lastViewedCompanyId),
      fetchPolicy: 'cache-first',
    },
  );

  if (isNil(lastViewedCompanyId) || (loading && data === undefined)) {
    return undefined;
  }

  return data?.viewer?.isVisibilityAgentEnabled ?? false;
}
